import { render, staticRenderFns } from "./clubNewPost.vue?vue&type=template&id=563910ae&scoped=true"
import script from "./clubNewPost.vue?vue&type=script&lang=js"
export * from "./clubNewPost.vue?vue&type=script&lang=js"
import style0 from "./clubNewPost.vue?vue&type=style&index=0&id=563910ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563910ae",
  null
  
)

export default component.exports